import type { CourseItem, PublicConfig } from './shared/types';

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';
export const ADMIN_TOKEN_KEY = 'schedule_admin_token';

export async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (!headers.has('content-type') && init.body && !(init.body instanceof FormData)) {
    headers.set('content-type', 'application/json');
  }

  const token = window.localStorage.getItem(ADMIN_TOKEN_KEY);
  if (token && !headers.has('x-admin-token')) {
    headers.set('x-admin-token', token);
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...init,
    headers,
  });

  if (!response.ok) {
    const payload = await response.text();
    throw new Error(payload || `Request failed: ${response.status}`);
  }

  if (response.status === 204) {
    return undefined as T;
  }

  const contentType = response.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    return (await response.json()) as T;
  }

  return (await response.text()) as T;
}

export async function fetchSchedule(date: string): Promise<CourseItem[]> {
  return apiFetch<CourseItem[]>(`/api/schedule?date=${encodeURIComponent(date)}`);
}

export async function fetchConfig(): Promise<PublicConfig> {
  return apiFetch<PublicConfig>('/api/config');
}

export async function saveConfig(payload: Partial<PublicConfig & Record<string, string | boolean>>): Promise<void> {
  await apiFetch('/api/config', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function saveAdjustment(payload: Record<string, unknown>): Promise<void> {
  await apiFetch('/api/adjust', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function getStoredAdminToken(): string {
  return window.localStorage.getItem(ADMIN_TOKEN_KEY) ?? '';
}

export function setStoredAdminToken(value: string): void {
  window.localStorage.setItem(ADMIN_TOKEN_KEY, value);
}
